import React, { useContext } from 'react';
import { type RestSimpleTeamLaCard } from '@bbkAdminUtils/api-client/rest-la-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnel/components/customer_html/customer_html';
import { FunnelContext } from '@bbkFunnelComponents/FunnelContext';
import { LossGridItem } from '@bbkFunnelComponents/loss/sections/grid-item';
import { LossTitle } from '@bbkFunnelComponents/loss/sections/title';
import Icon from '@bbkFunnelUtils/exit-icon';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

import './loss-simple-team.scss';

type Props = {
  card: RestSimpleTeamLaCard;
  onClick?: () => void;
};

const LossSimpleTeam: React.FC<Props> = ({
  card,
  card: {
    requires: { teamMembers, title },
  },
  onClick,
}) => {
  const { isPreview } = useContext(FunnelContext);
  const items = teamMembers.map((item, index) => (
    <div key={index} className="team-avatar-wrap">
      {item.avatar ? (
        <img className="loss-photo" src={item.avatar} alt={item.name} />
      ) : (
        <div className="loss-icon">
          {item.avatarText ? (
            <span className="loss-icon-text">{item.avatarText}</span>
          ) : (
            <Icon name="person" classes="loss-icon-user" />
          )}
        </div>
      )}
      {item.name && <div className="name">{item.name}</div>}
    </div>
  ));

  return (
    <LossGridItem
      classes={cs('bbk-loss-simple-team', makeClassNameSafe(card.name))}
      onClick={isPreview ? onClick : () => undefined}
    >
      <LossTitle>
        <CustomerHtml value={title} />
      </LossTitle>
      <div className="bbk-loss-simple-team-inner">
        <div className="list-team">{items}</div>
      </div>
    </LossGridItem>
  );
};
export default LossSimpleTeam;
